import PropTypes from 'prop-types'
import styles from './SidebarLink.module.scss'

const SidebarLink = ({ src, alt, text }) => {
	return (
		<div className={styles.SideBarLink}>
			<img className={styles.sidebarIcon} src={src} alt={alt} />
			<p className={styles.linkText}>{text}</p>
		</div>
	)
}

SidebarLink.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
}

export default SidebarLink
